import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// const fs = require('fs');
// let logopage = fs.readFileSync('https://emp.joball.net/clouddoc/caa39434539c40cb95d631b215f0f9dc/20231026210910770.png', 'utf-8');// 同步读取文件 放在页眉的图标
// var logopage = new Image();
// logopage.crossOrigin = 'anonymous';
// logopage.src = 'https://emp.joball.net/clouddoc/caa39434539c40cb95d631b215f0f9dc/20231026210910770.png?'+Date.now();

var noTableHeight = 0; //table外的元素高度
export const downloadPDF = (title, html, lableList, logopage, type, callback) => {// type传有效值pdf则为横版
  if (lableList) {
    const pageHeight = Math.floor(277 * html.scrollWidth / 190) +20; //计算pdf高度
    for (let i = 0; i < lableList.length; i++) { //循环获取的元素
      const multiple = Math.ceil((lableList[i].offsetTop + lableList[i].offsetHeight) / pageHeight); //元素的高度
      if (isSplit(lableList, i, multiple * pageHeight)) { //计算是否超出一页
        var _H = '' //向pdf插入空白块的内容高度
        // if(lableList[i].localName !== 'tr'){ //判断是不是表格里的内容
          _H = multiple * pageHeight - (lableList[i].offsetTop + lableList[i].offsetHeight);
        // }else{
        //   _H = multiple * pageHeight - (lableList[i].offsetTop + lableList[i].offsetHeight + noTableHeight) +20;
        // }
        var newNode = getFooterElement(_H);  //向pdf插入空白块的内容
        const divParent = lableList[i].parentNode; // 获取该div的父节点
        const next = lableList[i].nextSibling; // 获取div的下一个兄弟节点
        // 判断兄弟节点是否存在
        if (next) {
          // 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
          divParent.insertBefore(newNode, next);
        } else {
          // 否则向节点添加最后一个子节点
          divParent.appendChild(newNode);
        }
      }
    }
  }
  html2canvas(html, {
    allowTaint: false,
    taintTest: false,
    logging: false,
    useCORS: true,
    dpi: window.devicePixelRatio * 1, 
    scale: 1 // 按比例增加分辨率
  }).then(canvas => {
    var pdf = new jsPDF('p', 'mm', 'a4'); // A4纸，纵向
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var a4w = type ? 277 : 190; var a4h = type ? 190 : 277; // A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
    var imgHeight = Math.floor(a4h * canvas.width / a4w); // 按A4显示比例换算一页图像的像素高度
    var renderedHeight = 0;
    printWater(ctx);
    while (renderedHeight < canvas.height) {
      var page = document.createElement('canvas');
      page.width = canvas.width;
      page.height = Math.min(imgHeight, canvas.height - renderedHeight);// 可能内容不足一页
      // 用getImageData剪裁指定区域，并画到前面创建的canvas对象中
      page.getContext('2d', { willReadFrequently: true }).putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
      pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 20, a4w, Math.min(a4h, a4w * page.height / page.width)); // 添加图像到页面，保留10mm边距
      //添加页眉的logo
      pdf.addImage(logopage,'PNG', 25, 3, 30, 10);
      renderedHeight += imgHeight;
      if (renderedHeight < canvas.height){
        pdf.addPage();// 如果后面还有内容，添加一个空页
      }
      // delete page;
    }
    // 保存文件
    if (type == 'batchExport') {
      let filename = title;
      let datauri = pdf.output('dataurlstring');
      let file = dataURLtoFile(datauri, filename);
      callback(file);
      return file
    } else {
      pdf.save(title + ".pdf");
    }
  });
}
  // pdf截断需要一个空白位置来补充
function getFooterElement(remainingHeight, fillingHeight = 0) {
  const newNode = document.createElement('div');
  newNode.style.background = '#ffffff';
  newNode.style.width = 'calc(100% + 8px)';
  newNode.style.marginLeft = '-4px';
  newNode.style.marginBottom = '0px';
  newNode.classList.add('divRemove');
  // newNode.style.height = (remainingHeight + fillingHeight) + 'px';
  newNode.style.height = '24px';
  return newNode;
}
// function isSplit(nodes, index, pageHeight) {
//   return nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight
// }
function isSplit(nodes, index, pageHeight) {
  // 判断是不是tr 如果不是高度存起来
  // 表格里的内容要特殊处理
  // tr.offsetTop 是tr到table表格的高度
  // 所以计算高速时候要把表格外的高度加起来
  // 生成的pdf没有表格了这里可以不做处理 直接计算就行
  // if(nodes[index].localName !== 'tr'){  //判断元素是不是tr
    noTableHeight+= nodes[index].clientHeight
  // }
  // if(nodes[index].localName !== 'tr'){ 
  return nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight;
  // } else {
  //   return nodes[index].offsetTop + nodes[index].offsetHeight + noTableHeight < pageHeight && nodes[index + 1] && nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight + noTableHeight > pageHeight;
  // }
}
 // 计算元素距离顶部位置
function calc(dom, distance) {
  distance = distance || 0
  if (['BODY',null].includes(dom.offsetParent.nodeName)) {
    distance += dom.offsetTop
    return distance
  } else {
    distance += dom.offsetTop
    return calc(dom.offsetParent,distance)
  }
}
// export const downloadPDF = (page, logopage, name, type, callback) => {
//   // // 特别重要：当页面超过一页，出现滚动条，滚动的部分生成的图片为空白
//   // window.pageYoffset = 0
//   // document.documentElement.scrollTop = 0
//   // document.body.scrollTop = 0
//   let file;
//   html2canvas(page, {
//     useCORS: true, //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
//     dpi: 300, // 提升导出的文件的分辨率
//     scale: 2 // 提升导出的文件的分辨率
//   }).then(function (canvas) {
//     canvas2PDF(canvas, name, type, logopage);
//     if(type == 'batchExport'){
//       file = canvas2PDF(canvas, name, type, logopage);
//       callback(file);
//     }
//   });
// };

// const canvas2PDF = (canvas, name, type, logopage) => {
//   let contentWidth = canvas.width;
//   let contentHeight = canvas.height;
//   //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
//   let imgWidth = 595.28;
//   let imgHeight = 592.28 / contentWidth * contentHeight;
//   //一页pdf显示html页面生成的canvas高度;
//   let pageHeight = contentWidth / 592.28 * 841.89;
//   let totalHeight = contentHeight;
//   // 第一个参数： l：横向  p：纵向
//   // 第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）
//   let context = canvas.getContext('2d');

//   // 给页眉添加logo
//   let renderedHeight = 0;
//   let a4w = 190, a4h = 257 //A4大小，210mm x 297mm，左右保留10mm，上下保留20mm的边距，显示区域190x257
//   let imgHeightlogo = Math.floor(a4h * contentWidth / a4w) //按A4显示比例换算一页图像的像素高度
//   // let logo = document.getElementById("logo");    //放在页眉的图标
//   let pagelogo = document.createElement("canvas");

//   printWater(context);
//   let pdf = new jsPDF("p", "pt");
//   let pageData = canvas.toDataURL('image/jpeg', 1.0);
//   // console.log('canvas', canvas)
//   // console.log('imgHeight', imgHeight)
//   let position = 0;
//   // 如果页面高度超过了生成pdf一页纸的高度就要进行分页
//   if (totalHeight < pageHeight) {
//     // pagelogo.width = contentWidth;
//     // pagelogo.height = Math.min(imgHeightlogo, contentHeight - renderedHeight);//可能内容不足一页
//     // //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
//     // pagelogo.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, contentWidth, Math.min(imgHeight, contentHeight - renderedHeight)), 0, 0);
//     // //添加图像到页面，保留10mm/20mm边距
//     // pdf.addImage(pagelogo.toDataURL('image/jpeg', 1.0), 'JPEG', 10, 20, a4w, Math.min(a4h, a4w * pagelogo.height / pagelogo.width));    
//     // //添加页眉的logo
//     // pdf.addImage(logopage, 'PNG', 5, 3);
//     // renderedHeight += imgHeightlogo;

//     pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
//   } else {
//     while (totalHeight > 0) {
//       pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
//       totalHeight -= pageHeight;
//       position -= 841.89;
//       //避免添加空白页
//       if (totalHeight > 0) {
//         pdf.addPage();
//       }
//     }
//   }
//   if (type == 'batchExport') {
//     let filename = name;
//     let datauri = pdf.output('dataurlstring');
//     let file = dataURLtoFile(datauri, filename);
//     return file
//   } else {
//     pdf.save(name + ".pdf");
//   }
// };
// 打印水印
const printWater = (context) => {
  context.font = '100px Palatino'
  context.fillStyle = 'rgba(180, 180, 180, 0.3)';
  let height = 0;
  context.save();
  let pageHeight = context.canvas.height / 592.28 * 841.89
  while (height < context.canvas.height) {
    context.save();
    context.translate(0, height) // 移动原点位置
    context.rotate(Math.PI / 4); // 旋转
    context.fillText('Jobstart 保密文件', 580, -80);
    context.restore();
    height += 841.89;
  }
  context.restore();
}

//将pdf的流文件---》blob对象
const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    undefined
    u8arr[n] = bstr.charCodeAt(n);
  }
  //转换成file对象
  // return new File([u8arr], filename, {
  //   type: mime
  // });
  //转换成成blob对象
  return new Blob([u8arr],{type:mime},{fileName:filename});
}

// export default downloadPDF;